import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-support-export-tickets-quick-action',
  templateUrl: './support-export-tickets-quick-action.component.html',
  styles: [
  ],
})
export class SupportExportTicketsQuickActionComponent implements OnInit {

  @Input() tickets: any[] = [];

  @Input() filteredTickets: any[] = [];


  exportScope: string = 'all';

  exportFormat: string = 'csv';


  constructor(
    public activeModal: NgbActiveModal
  ) {}


  ngOnInit(): void {

  }


  // =====================================================
  // TICKET COUNT
  // =====================================================

  get exportTicketCount(): number {

    return this.exportScope === 'filtered'
      ? this.filteredTickets.length
      : this.tickets.length;

  }


  // =====================================================
  // CLOSE
  // =====================================================

  close(): void {

    this.activeModal.dismiss();

  }


  // =====================================================
  // EXPORT
  // =====================================================

  exportTickets(): void {

    this.activeModal.close({

      success: true,

      scope:
        this.exportScope,

      format:
        this.exportFormat

    });

  }

}